import { string, object } from "yup";
import { type SelectAvailablePaymentPrefsFormInitialValuesType } from "./types";

export const CREATE_NEW_PAYMENT_OPTION = "-1";
export const SelectAvailablePaymentPrefsFormSchema = object().shape({
  availablePaymentPrefsOption: string().required("A payment method is required"),
});

export const SelectAvailablePaymentPrefsFormInitialValues: SelectAvailablePaymentPrefsFormInitialValuesType =
  {
    availablePaymentPrefsOption: CREATE_NEW_PAYMENT_OPTION,
  };
